import { render, staticRenderFns } from "./skPlan.vue?vue&type=template&id=1acd05ec&scoped=true"
import script from "./skPlan.vue?vue&type=script&lang=js"
export * from "./skPlan.vue?vue&type=script&lang=js"
import style0 from "./skPlan.vue?vue&type=style&index=0&id=1acd05ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acd05ec",
  null
  
)

export default component.exports